module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.treefortsystems.app.relearn",
  "PUBLIC_API_DOMAIN_NAME": "api.relearn.org",
  "PUBLIC_API_DOMAIN_NAME_WEB": "api.relearn.org",
  "PUBLIC_API_ENDPOINT": "https://api.treefortsystems.com/v1",
  "PUBLIC_APPLE_ID": "6447377487",
  "PUBLIC_APP_ICON_BACKGROUND_COLOR": "#36427D",
  "PUBLIC_APP_ICON_FOREGROUND_PADDING": "0.15",
  "PUBLIC_APP_ICON_FOREGROUND_URL": "https://cdn.treefortsystems.com/file/treefort-ott-prod/ce6f6d04-cb44-4988-aab8-9226dc991a5a/uploads/16795d1d-0603-4e62-972b-84f370fe116e.png",
  "PUBLIC_APP_ID": "133",
  "PUBLIC_APP_NAME": "Relearn",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://app.relearn.org",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "ad75d20c-ee40-4bdf-b5fc-bc5aa5b0fb16",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "app.relearn.org",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_relearn",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6NDg5MjUzNTEwMzAwOndlYjo1ZWYwNzAzY2RmMDY1N2M2ZjgyMTU5IiwiYXBpS2V5IjoiQUl6YVN5Q3h2Q2NqT2dFYl9aUzYtOUJ4X0dYYzBtb1Z0SXJKTXZBIiwicHJvamVjdElkIjoicmVsZWFybi1hcHAtNWVlZmQiLCJhdXRoRG9tYWluIjoicmVsZWFybi1hcHAtNWVlZmQuZmlyZWJhc2VhcHAuY29tIiwibWVhc3VyZW1lbnRJZCI6IkctSzBQWUQ4REtYMiIsInN0b3JhZ2VCdWNrZXQiOiJyZWxlYXJuLWFwcC01ZWVmZC5hcHBzcG90LmNvbSIsIm1lc3NhZ2luZ1NlbmRlcklkIjoiNDg5MjUzNTEwMzAwIn0=",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BEqkNZ5yCTgFHA6pbyBdoZRe06nFOVIzwXsOuMb1hGCCEAL9OllKf_KPrgm1lVCeucleBzm4oX0OFS194e7FQxw",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#215d83",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "52",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/ce6f6d04-cb44-4988-aab8-9226dc991a5a/uploads/1af5d8b0-e248-4c6d-988f-ff0cf934ed69.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.treefortsystems.app.relearn",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PASSWORDLESS": "disabled",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2R7br6gT7l08cofCHP0INKB4dI9",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "#36427D",
  "PUBLIC_SPLASH_LOGO_URL": "https://cdn.treefortsystems.com/file/treefort-ott-prod/ce6f6d04-cb44-4988-aab8-9226dc991a5a/uploads/16795d1d-0603-4e62-972b-84f370fe116e.png",
  "PUBLIC_SPLASH_LOGO_WIDTH": "100",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#215d83",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn.treefortsystems.com/file/treefort-ott-prod/ce6f6d04-cb44-4988-aab8-9226dc991a5a/uploads/16795d1d-0603-4e62-972b-84f370fe116e.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "100",
  "PUBLIC_TENANT_ID": "ce6f6d04-cb44-4988-aab8-9226dc991a5a",
  "PUBLIC_MAJOR_VERSION": "32",
  "PUBLIC_MINOR_VERSION": "4",
  "PUBLIC_PATCH_VERSION": "0",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "app.relearn.org@32.4.0",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "dark"
}
